module.exports = __webpack_public_path__ + "img/回升lv4.0b752ba0.png";